import { tolgee } from 'services/i18n/tolgee';

const specialCharacters = [
  '`',
  '!',
  '@',
  '#',
  '$',
  '%',
  '^',
  '&',
  '*',
  '(',
  ')',
  '_',
  '+',
  '=',
  '-',
  '\\',
  '|',
  ']',
  '[',
  '{',
  '}',
  '"',
  "'",
  ';',
  ':',
  ',',
  '<',
  '.',
  '>',
  '/',
  '?',
];
/**
 *
 * @param password 密码
 * @param username 帐号名
 * @param mode 严格模式or简单模式，严格模式，检验全开，简单模式仅校验长度在8-20位内，当下默认简单模式
 * @doc https://leyan.yuque.com/czpqnb/pd/bb9cana2malhwe8o
 * @returns
 */

const passwordValidator = (
  password: string,
  username?: string,
  mode: 'simple' | 'strict' = 'simple',
): {
  valid: boolean;
  message: string;
} => {
  if (!password) {
    return {
      valid: false,
      message: tolgee.t(
        mode === 'simple'
          ? 'ViewStartups.registry.form.item.password.validator.error.length'
          : 'ViewStartups.registry.form.item.password.validator.error.required',
      ),
    };
  }
  if (password.length < 8 || password.length > 20) {
    return {
      valid: false,
      message: tolgee.t('ViewStartups.registry.form.item.password.validator.error.length'),
    };
  }
  if (mode === 'simple') {
    return {
      valid: true,
      message: '',
    };
  }
  if (!/[0-9]/.test(password)) {
    return {
      valid: false,
      message: tolgee.t('ViewStartups.registry.form.item.password.validator.error.no.number'),
    };
  }
  if (!/[a-zA-z]/.test(password)) {
    return {
      valid: false,
      message: tolgee.t('ViewStartups.registry.form.item.password.validator.error.no.alphabet'),
    };
  }
  if (specialCharacters.every((x) => !password.includes(x))) {
    return {
      valid: false,
      message: tolgee.t(
        'ViewStartups.registry.form.item.password.validator.error.no.special.characters',
      ),
    };
  }
  if (username && password.includes(username)) {
    return {
      valid: false,
      message: tolgee.t(
        'ViewStartups.registry.form.item.password.validator.error.include.username',
      ),
    };
  }

  return {
    valid: true,
    message: '',
  };
};

export default passwordValidator;
